import React, { useEffect, useRef, useState } from 'react';
import Datepicker from '../../../../components/elements/form/datepicker';
import Teaxtarea from '../../../../components/elements/form/textarea';
import Loader from '../../../../components/loader';
import CreatePurchaseRequestParts from './createPurchasedRequestParts';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import moment from 'moment';
import Button from '../../../../components/elements/button';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import SelectBox from '../../../../components/elements/form/selectBox';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { usePurchaseOrderApi } from '../../../../store/api/hooks/purchaseOrderApiHook';
import { useVendorsApi } from '../../../../store/api/hooks/vendorsApiHook';
import { URLS } from '../../../../_config';
import { Link } from 'react-router-dom';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';

interface ViewPurchaseRequestProps {
	PrID: number;
	mode?: 'view' | 'approve' | 'convert-po';
	onCreate?: () => void;
	onCancel?: (open?:any) => void;
}

const ViewPurchaseRequest: React.FC<ViewPurchaseRequestProps> = ({ PrID, mode = 'view', onCancel = () => { }, onCreate = () => { } }) => {
	const divRef = useRef<any>(null);

	const purchaseApi = usePurchaseRequestApi();
	const commonApi: any = useCommonApi();
	const purchaseOrderApi = usePurchaseOrderApi();
	const sparePartsApi = useSpearPartsApi();

	const [showLoader, setShowLoader] = useState(false);
	const [lineItemMode, setLineItemMode] = useState('');
	const [lineItems, setLineItems] = useState<any[]>([]);
	const [vendorList, setVendorList] = useState<any[]>([]);
	const [pr, setPr] = useState<any>(null);

	const [updatePartWithNewPrice, setUpdatePartWithNewPrice] = useState<boolean>(false);

	const [lastsearchpartsvendor, setLastearchpartsvendor] = useState<any[]>([]);


	const [formData, setFormData] = useState({
		purchaseRequestCode: '',
		purchaseRequestType: '',
		requiredByDate: null as Date | null,
		facilityName: '',
		notes: '',
		reason: '',
		requesterName: '',
		approverName: '',
		approvedDate: ``,
	});

	const handleVendorSearch = async (inputval: any): Promise<any[]> => {
		return new Promise((resolve, reject) => {
			commonApi.GetServiceprovidertList({
				pageSize: 0,
				serviceProviderTypeID: 6,
			}, (resp: any) => {
				if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
					/*
					const deptlist = resp.vendorList.map((user: any) => {
						return {
							label: user.name,
							value: user.vendorID,
						};
					});
					resolve(deptlist);
					*/
					resolve(resp.vendorList.map((vendor: any) => {
						return {
							label: vendor.name,
							value: vendor.vendorID,
							...vendor
						};
					}));
				} else {
					resolve([]);
				}
			}, (error: any) => {
				reject([])
			})
		});
	};

	const onOutsideClick = () => {
		handleOnClickCellEdit()
	}

	const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
		if (identifier) {
			const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
			const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
			const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
			if (previewElement && editElement) {
				if (cellElement.id === `${identifier}`) {
					if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
					if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
				}
			}
		}

		//resetOthersCellEditState(`part-item-name-${index}`);
		const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
		//console.log("editableList", editableList);
		for (let i = 0; i < editableList.length; i++) {
			const editableCell = editableList[i];
			const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
			const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
			if (editableCell.id !== `${identifier}`) {
				if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
				if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
			}
		}

	};


	const spearPartsAPI: any = useSpearPartsApi();

	const handleVendorsSearch = async (partID: any): Promise<any[]> => {
		return new Promise((resolve, reject) => {
			spearPartsAPI.getSpearPartsList({ partsID: partID }, (data: any) => {
				const partDetails = data?.sparePartsList ? data.sparePartsList[0] : null;
				resolve(partDetails?.vendors || []);
			}, (error: any) => {
				resolve([]);
			});
		});
	};

	useEffect(() => {
		const init = async () => {
			if (!PrID) return;
			const vendorlist = await handleVendorSearch(``);
			setVendorList(vendorlist);

			setShowLoader(true);
			const prdetails: any = await new Promise((resolve, reject) => {
				purchaseApi.GetPurchaseRequestById({ PurchaseRequestID: PrID }, (resp: any) => {
					if (resp && resp.purchaseRequestID > 0) resolve(resp);
					else reject('No PR found');
				}, reject);
			}).catch((e) => {
				setShowLoader(false);
				return null;
			});

			if (prdetails) {
				console.log("PR Details", prdetails);
				setPr(prdetails);
				setFormData({
					purchaseRequestCode: prdetails.purchaseRequestCode,
					purchaseRequestType: prdetails.purchaseRequestTypeName,
					requiredByDate: moment.utc(prdetails.requiredByDate).local().toDate(),
					facilityName: prdetails.facilityName,
					notes: prdetails.notes,
					reason: prdetails.reason,
					requesterName: prdetails.requesterName,
					approverName: prdetails?.approverName || ``,
					approvedDate: prdetails?.approvedDate ? moment.utc(prdetails.approvedDate).local().format(`MM/DD/YYYY`) : ``,
				});

				if (prdetails.purchaseRequestTypeID === 1 && prdetails.purchaseRequestItemList) {
					setLineItemMode('parts');
					const items = prdetails.purchaseRequestItemList.map((o: any) => ({
						partsID: o.partsID,
						vendorPartCode: o.partsCode,
						vendorPartName: o.partName,
						vendorID: o.vendorID,
						vendorName: o.vendorName,
						requiredQty: o.requiredQty,
						unitID: o.unitID,
						unitPrice: (o.totalAmount / o.requiredQty) || 0,
						unitName: o.unitCode,
						totalAmount: o.totalAmount,
					}));
					setLineItems(items);
				}

				if ((prdetails.purchaseRequestTypeID === 2 || prdetails.purchaseRequestTypeID === 3) && prdetails.purchaseAsset) {
					setLineItemMode('assets');
					const items = prdetails.purchaseAsset.map((o: any) => ({
						//assetID: o.assetID,
						assetName: o.assetName,
						vendorID: o.vendorID,
						vendorName: o.vendorName,
						requiredQty: o.requiredQty,
						unitCode: o.unitCode || 'Each',
						unitPrice: (o.totalAmount / o.requiredQty) || 0,
						totalAmount: o.totalAmount || 0,
					}));
					setLineItems(items);
				}

			}

			setShowLoader(false);
		};

		init();
	}, [PrID]);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (divRef.current && !divRef.current.contains(event.target)) {
				onOutsideClick();
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onOutsideClick]);

	useEffect(() => {
		const handleKeyDown = (event: any) => {
			if (event.key === 'Escape') {
				onOutsideClick();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [onOutsideClick]);

	const onSubmitAction = (statusID: number) => {
		const payload = {
			purchaseRequestID: PrID,
			purchaseRequestStatusID: statusID
		};
		setShowLoader(true);
		purchaseApi.SaveProcessPurchaseRequest(
			payload,
			(resp: any) => {
				setShowLoader(false);
				if (resp.code === 200) {
					if (statusID === 3) {
						toast.success('Purchase Request Approved Successfully');
						onCreate();
					} else if (statusID === 4) {
						toast.success('Purchase Request Rejected Successfully');
						onCreate();
					} else if (statusID == 2){
						toast.success('Purchase Request has been send for approval Successfully');
						onCreate();
					}
				} else {
					toast.error(resp.message);
				}
			},
			() => {
				setShowLoader(false);
				toast.error('Failed to move asset');
			}
		);
	};

	const partsApi: any = useSpearPartsApi();

	const mapPartVendor = async (payload: any) => {
		const vendorresp: any = await new Promise((resolve, reject) => {
			partsApi.SavePartsVendorMap(payload, (data: any) => {
				resolve(data);
			}, (error: any) => {
				reject(error);
			});
		}).catch((error: any) => {
			console.error("Error saving vendor map:", error);
			return null;
		});
	};

	const onConverPR_PO = async () => {
		var prpayload: any = {
			purchaseRequestID: pr.purchaseRequestID,
			purchaseRequestCode: pr.purchaseRequestCode,
			facilityID: pr.facilityID,
			subFacilityID: pr.subFacilityID,
			purchaseRequestTypeID: pr.purchaseRequestTypeID,
			purchaseRequestStatusID: pr.purchaseRequestStatusID,
			requesterID: pr.requesterID,
			requiredByDate: pr.requiredByDate,
			notes: pr.notes,
			reason: pr.reason,
			purchaseRequestDetails: [],
			potentialAsset: [],
			purchaseRequestWorkOrder: pr.purchaseWO && Array.isArray(pr.purchaseWO) && pr.purchaseWO.length > 0 ? pr.purchaseWO.map((o: any) => {
				return {
					workOrderID: o.workOrderID,
				};
			}) : []
		};

		if (lineItemMode === `parts` && lineItems.length > 0) {
			const invalidparts = lineItems.filter((o: any) => !o.vendorID || !o.partsID);
			if (invalidparts.length > 0) {
				toast.error(`Please select vendor for all parts!`);
				return;
			}
			prpayload.potentialAsset = [];
			prpayload.purchaseRequestDetails = lineItems.map((o: any) => {
				console.log("Mapping part item", o);
				return {
					partsID: o.partsID,
					vendorID: o.vendorID,
					requiredQty: o.requiredQty,
					unitID: o.unitID,
					totalAmount: o.totalAmount
				}
			});
		}

		if (lineItemMode === `assets` && lineItems.length > 0) {
			console.log("Line Items", lineItems);
			//const invalidassets = lineItems.filter((o: any) => !o.vendorID || !o.assetID);
			const invalidassets = lineItems.filter((o: any) => !o.vendorID);
			if (invalidassets.length > 0) {
				toast.error(`Please select vendor for all assets!`);
				return;
			}
			prpayload.potentialAsset = lineItems.map((o: any) => {
				return {
					//assetID: o.assetID,
					assetName: o.assetName,
					vendorID: o.vendorID,
					requiredQty: o.requiredQty,
					unitID: 5
				}
			});
			prpayload.purchaseRequestDetails = [];
		}

		if (updatePartWithNewPrice) {
			lineItems.map((part: any) => {
				console.log("Updating partID:", part.partsID,)
				handleVendorsSearch(part.partsID).then((vendors: any) => {
					console.log("Fetched vendors for part:", vendors);
					let mappedVendor: any = null;

					for (const vendor of vendors) {
						if (+vendor.vendorID === +part.vendorID) {
							mappedVendor = vendor;
						}
					}

					if (mappedVendor) {
						// update part vendor pricing
						console.log('Update part vendor map')
						const payload = {
							partsID: part.partsID,
							vendorID: part.vendorID,
							isPreferred: mappedVendor.isPreferred,
							vendorPartCode: mappedVendor.vendorPartCode || '',
							costPerUnit: +part.unitPrice,
							partsVendorMapID: mappedVendor.partsVendorMapID

						};
						mapPartVendor(payload);
					} else {
						// create new part vendor pricing
						console.log('Create new part vendor map')
						const payload = {
							partsID: part.partsID,
							vendorID: part.vendorID,
							isPreferred: false,
							vendorPartCode: '',
							costPerUnit: +part.unitPrice
						};
						mapPartVendor(payload);
					}
				});
			})
		}

		setShowLoader(true);
		purchaseApi.SavePurchaseRequest(prpayload, (resp: any) => {
			if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true) {
				purchaseOrderApi.SavePurchaseOrderFromPR({ purchaseRequestID: pr.purchaseRequestID }, (data: any, msg: any) => {
					toast.success(msg);
					setShowLoader(false);
					onCreate();
				}, (error: any) => {
					setShowLoader(false);
					toast.error(error);
				});
			} else {
				toast.error(resp?.message || `Failed to update vendor ID in the Purchase Request!`);
			}
		}, (error: any) => {
			toast.error(error);
		});
	};

	const [POLIST, setPOLIST] = useState<any[]>([]);

	useEffect(() => {
		if (pr?.purchaseRequestStatusID === 7) {
			purchaseOrderApi.getOrderList({
				purchaseRequestID: pr.purchaseRequestID
			}, (resp: any) => {
				setPOLIST(resp.purchaseOrderList);
			}, (error: any) => { });
		}
	}, [pr]);

	const getPartPriceByVendor = async (partID: any, vendorID: any): Promise<any> => {
		return new Promise((resolve, reject) => {
			sparePartsApi.getSpearPartsList({
				partsID: partID
			}, (resp: any) => {
				const vendors: any = resp.sparePartsList[0]?.vendors || [];
				console.log("Part price by vendor resp", vendors);
				const vendor = vendors.find((v: any) => +v.vendorID === +vendorID);
				resolve(vendor?.costPerUnit || 0);
			}, (error: any) => {
				reject(0);
			});
		});
	};


	const [partLoader, setPartLoader] = useState<any>([]);

	return (
		<div className="flex flex-col h-full relative">
			{showLoader && (
				<div className="absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30">
					<Loader />
				</div>
			)}

			{!showLoader && (
				<>
					{/* Main Content */}
					<div className="pt-4 flex-1">
						<div className="bg-green-50 py-2 px-3">
							<h6 className="text-[0.813rem] font-semibold">Purchase Request ID</h6>
							<p className="text-[0.813rem] font-normal mt-2">{formData.purchaseRequestCode || '...'}</p>
						</div>

						<div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
							<div className='w-[12.5rem] text-[#767676] mr-2'>Location</div>
							<div className='text-[#323233]'>{formData.facilityName}</div>
						</div>

						<div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
							<div className='w-[12.5rem] text-[#767676] mr-2'>Purchase Type</div>
							<div className='text-[#323233]'>{formData.purchaseRequestType || '-'}</div>
						</div>



						{lineItemMode === 'parts' && (
							<div>
								<h4 className='font-semibold text-[0.938rem] py-4 uppercase'>ITEMS</h4>

								<div className="border border-[#043E6133] rounded-[5px] parts-table">
									<div className="flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]">
										<div className="min-w-[19%] flex-grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Item Code</div>
										<div className="min-w-[20%] flex-grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Item Name</div>
										{(mode === `convert-po` || pr.purchaseRequestStatusID > 6) && <div className="w-[20%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Vendor</div>}
										<div className="w-[13%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Est. Unit Cost</div>
										<div className="w-[14%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Req. Quantity</div>
										<div className="w-[14%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end">Est. Total Cost</div>
									</div>
									<div className={``} ref={divRef}>
										{lineItems.length === 0 && (
											<div className="flex items-center justify-center h-24 text-gray-500">
												No parts added yet.
											</div>
										)}


										{lineItems.map((part, index) => {
											return (
												<div key={index} className={`flex items-center flex-nowrap ${index < lineItems.length - 1 ? "border-b border-[#043E6133]" : ""}`}>
													<div className=" min-w-[19%]  flex-grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
														<div className={`line-clamp-1 text-ellipsis`}>{part.vendorPartCode || '--'}</div>
													</div>
													<div className="min-w-[20%] flex-grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
														{part.vendorPartName || '--'}
													</div>
													{mode === `convert-po` ? (
														<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`part-vendor-item-${index}`} onClick={(e: any) => {
															handleOnClickCellEdit(`part-vendor-item-${index}`, e);
															e.stopPropagation();
															e.preventDefault();
														}}>
															<div className={`preview-value line-clamp-1`}>{part.vendorName || '--'} </div>
															<div className={`edit-value hidden`}>
																<SelectBox
																	label={``}
																	value={{ label: part.vendorName, value: part.vendorID }}
																	onChange={async (value: any) => {
																		console.log("Selected vendor value", value);
																		const updatedParts = [...lineItems];
																		setPartLoader((prev: any) => {
																			const newLoader = [...prev];
																			if (!newLoader[index]) newLoader[index] = {};
																			newLoader[index].vendorPriceLoading = true;
																			return newLoader;
																		});
																		//



																		updatedParts[index].vendorID = value?.value || null; // Assuming value has a value property
																		updatedParts[index].vendorName = value?.label || ``; // Assuming value has a label property
																		const cronologicalvendor = lastsearchpartsvendor.find(o => +o.vendorID === +value?.value);
																		console.log("cronologicalvendor", cronologicalvendor);
																		if (cronologicalvendor) {
																			updatedParts[index].pricePerUnit = cronologicalvendor.price || 0;
																			updatedParts[index].totalAmount = +updatedParts[index].requiredQty * cronologicalvendor.price;
																		}
																		const partPrice: any = await getPartPriceByVendor(part.partsID, value?.value);
																		updatedParts[index].unitPrice = partPrice;
																		updatedParts[index].totalAmount = (updatedParts[index].requiredQty || 0) * partPrice;
																		setPartLoader((prev: any) => {
																			const newLoader = [...prev];
																			if (!newLoader[index]) newLoader[index] = {};
																			newLoader[index].vendorPriceLoading = false;
																			return newLoader;
																		});

																		setTimeout(() => {
																			setLineItems(updatedParts);
																		}, 200);
																	}}
																	isLoading={partLoader[index]?.vendorPriceLoading || false}
																	required
																	placeholder='Select Vendor'
																	options={vendorList.map((vendor: any) => {
																		return { label: vendor.name, value: vendor.vendorID, ...vendor }
																	})}
																	className={`!my-0`}
																	customStyleOption={{ control: (base) => ({ ...base, marginTop: `0rem`, minHeight: '32px' }) }}
																	//async={true}
																	isClearable={true}
																	defaultOptions={true}
																/* asyncLoadOptions={async (inputValue: string) => {
																	return handleVendorSearch(inputValue);
																}} */
																/>
															</div>
														</div>
													) : (
														<>
															{(pr.purchaseRequestStatusID > 6) && <div className="min-w-[20%] flex-grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
																{part.vendorName || '--'}
															</div>}
														</>
													)}
													{/* Unit Price - Editable only in convert-po mode */}
													{mode === 'convert-po' ? (
														<div className="w-[13%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`part-unit-price-${index}`} onClick={(e: any) => {
															handleOnClickCellEdit(`part-unit-price-${index}`, e);
															e.stopPropagation();
															e.preventDefault();
														}}>
															<div className={`preview-value line-clamp-1 text-right`} title={`Click here to edit unit price`}>
																${part.unitPrice?.toFixed(2) || '0.00'}
															</div>
															<div className={`edit-value hidden`}>
																<div className={`flex`}>
																	<span className={`border border-gray-300 bg-gray-50 rounded-tl rounded-bl flex items-center justify-center px-2 py-1 border-r-0`}>$</span>
																	<input
																		type="number"
																		name={`partunitprice${index}`}
																		className={`w-full border border-gray-300 rounded-tr rounded-br px-2 py-1 outline-none text-right input-no-spinner`}
																		value={part.unitPrice ?? 0}
																		min={0}
																		onInput={(e: any) => {
																			const newVal = parseFloat(e.target.value) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].unitPrice = newVal;
																			updatedItems[index].totalAmount = newVal * (updatedItems[index].requiredQty || 0);
																			setLineItems(updatedItems);
																		}}
																		onBlur={(e: any) => {
																			const newVal = parseFloat(e.target.value) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].unitPrice = newVal > 0 ? newVal : 0;
																			updatedItems[index].totalAmount = updatedItems[index].unitPrice * (updatedItems[index].requiredQty || 0);
																			setLineItems(updatedItems);
																		}}
																	/>
																</div>
															</div>
														</div>
													) : (
														<div className="w-[13%] min-w-[13%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
															${part.unitPrice?.toFixed(2) || '0.00'}
														</div>
													)}

													{/* Quantity - Editable only in convert-po mode */}
													{mode === 'convert-po' ? (
														<div className="w-[14%] min-w-[14%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`part-qty-${index}`} onClick={(e: any) => {
															handleOnClickCellEdit(`part-qty-${index}`, e);
															e.stopPropagation();
															e.preventDefault();
														}}>
															<div className={`flex items-center gap-1 flex-nowrap justify-end`}>
																<div className={`text-right`}>
																	<div className={`preview-value`} title={`Click here to edit quantity`}>{part.requiredQty || 0}</div>
																	<div className={`edit-value hidden`}>
																		<input
																			type="number"
																			name={`partrequiredqty${index}`}
																			className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner`}
																			value={part.requiredQty ?? 0}
																			min={0}
																			onInput={(e: any) => {
																				const newQty = parseFloat(e.target.value) || 0;
																				const updatedItems = [...lineItems];
																				updatedItems[index].requiredQty = newQty;
																				updatedItems[index].totalAmount = (updatedItems[index].unitPrice || 0) * newQty;
																				setLineItems(updatedItems);
																			}}
																			onBlur={(e: any) => {
																				const newQty = parseFloat(e.target.value) || 0;
																				const updatedItems = [...lineItems];
																				updatedItems[index].requiredQty = newQty > 0 ? newQty : 0;
																				updatedItems[index].totalAmount = (updatedItems[index].unitPrice || 0) * updatedItems[index].requiredQty;
																				setLineItems(updatedItems);
																			}}
																		/>
																	</div>
																</div>
																<div>{part.unitName || '--'}</div>
															</div>
														</div>
													) : (
														<div className="w-[14%] min-w-[14%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
															{part.requiredQty || 0} {part.unitName || '--'}
														</div>
													)}

													{/* Total - Editable only in convert-po mode (back-calculates unit price) */}
													{mode === 'convert-po' ? (
														<div className="w-[14%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`part-total-${index}`} onClick={(e: any) => {
															handleOnClickCellEdit(`part-total-${index}`, e);
															e.stopPropagation();
															e.preventDefault();
														}}>
															<div className={`preview-value line-clamp-1 text-right`} title={`Click here to edit total`}>
																${part.totalAmount?.toFixed(2) || '0.00'}
															</div>
															<div className={`edit-value hidden`}>
																<div className={`flex`}>
																	<span className={`border border-gray-300 bg-gray-50 rounded-tl rounded-bl flex items-center justify-center px-2 py-1 border-r-0`}>$</span>
																	<input
																		type="number"
																		name={`parttotal${index}`}
																		className={`w-full border border-gray-300 rounded-tr rounded-br px-2 py-1 outline-none text-right input-no-spinner`}
																		value={part.totalAmount ?? 0}
																		min={0}
																		onInput={(e: any) => {
																			const newTotal = parseFloat(e.target.value) || 0;
																			const qty = Number(part?.requiredQty) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].totalAmount = newTotal;
																			if (qty > 0) {
																				updatedItems[index].unitPrice = Number((newTotal / qty).toFixed(2));
																			}
																			setLineItems(updatedItems);
																		}}
																		onBlur={(e: any) => {
																			const newTotal = parseFloat(e.target.value) || 0;
																			const qty = Number(part?.requiredQty) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].totalAmount = newTotal > 0 ? newTotal : 0;
																			if (qty > 0) {
																				updatedItems[index].unitPrice = Number((updatedItems[index].totalAmount / qty).toFixed(2));
																			}
																			setLineItems(updatedItems);
																		}}
																	/>
																</div>
															</div>
														</div>
													) : (
														<div className="w-[14%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
															${part.totalAmount?.toFixed(2) || '0.00'}
														</div>
													)}
												</div>
											)
										})}
									</div>
								</div>

								{(mode === `convert-po`) &&

									<div className='my-4 flex'>
										<label className='flex items-center gap-3'>
											<input type="checkbox" checked={updatePartWithNewPrice} onChange={(e) => setUpdatePartWithNewPrice(e.target.checked)} />
											<span>Update vendor pricing for new price?</span>
										</label>
									</div>

								}


							</div>
						)}

						{lineItemMode === 'assets' && (
							<div>
								<h4 className="font-semibold text-[0.938rem] py-4 uppercase">ITEMS</h4>

								<div className="border border-[#043E6133] rounded-[5px] parts-table">
									<div className="flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]">
										<div className="min-w-[30%] flex-grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Item Name</div>
										{(mode === `convert-po` || pr.purchaseRequestStatusID > 6) && <div className="w-[30%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Vendor</div>}
										<div className="w-[20%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Est. Unit Cost</div>
										<div className="w-[20%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Req. Quantity</div>
										<div className="w-[20%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end">Est. Total Cost</div>
									</div>

									{lineItems.length === 0 && (
										<div className="flex items-center justify-center h-24 text-gray-500">
											No assets added yet.
										</div>
									)}



									{lineItems.map((asset, index) => {
										return (
											<div key={`asset-${index}`} className={`flex items-center flex-nowrap ${index < lineItems.length - 1 ? "border-b border-[#043E6133]" : ""}`}>
												<div className="min-w-[30%] flex-grow font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
													{asset.assetName || '--'}
												</div>
												{mode === `convert-po` ? (
													<div className="w-[30%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`asset-vendor-item-${index}`} onClick={(e: any) => {
														handleOnClickCellEdit(`asset-vendor-item-${index}`, e);
														e.stopPropagation();
														e.preventDefault();
													}}>
														<div className={`preview-value line-clamp-1`}>{asset.vendorName || '--'}</div>
														<div className={`edit-value hidden`}>

															<SelectBox
																label={``}
																value={{ label: asset.vendorName, value: asset.vendorID }}
																onChange={(value: any) => {
																	const updatedParts = [...lineItems];
																	updatedParts[index].vendorID = value?.value || null; // Assuming value has a value property
																	updatedParts[index].vendorName = value?.label; // Assuming value has a label property
																	setLineItems(updatedParts);
																}}
																required
																placeholder='Select Vendor'
																options={[]}
																customStyleOption={{ control: (base) => ({ ...base, marginTop: `0rem`, minHeight: '32px' }) }}
																className={`!my-0`}
																async={true}
																isClearable={true}
																defaultOptions={true}
																asyncLoadOptions={async (inputValue: string) => {
																	return handleVendorSearch(inputValue);
																}}
															/>
														</div>
													</div>
												) : (
													<>
														{(pr.purchaseRequestStatusID > 6) &&
															<div className="w-[30%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
																{asset.vendorName || '--'}
															</div>
														}
													</>
												)}

												{/* Unit Price - Editable only in convert-po mode */}
												{mode === 'convert-po' ? (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`asset-unit-price-${index}`} onClick={(e: any) => {
														handleOnClickCellEdit(`asset-unit-price-${index}`, e);
														e.stopPropagation();
														e.preventDefault();
													}}>
														<div className={`preview-value line-clamp-1 text-right`} title={`Click here to edit unit price`}>
															${asset.unitPrice?.toFixed(2) || '0.00'}
														</div>
														<div className={`edit-value hidden`}>
															<div className={`flex`}>
																<span className={`border border-gray-300 bg-gray-50 rounded-tl rounded-bl flex items-center justify-center px-2 py-1 border-r-0`}>$</span>
																<input
																	type="number"
																	name={`assetunitprice${index}`}
																	className={`w-full border border-gray-300 rounded-tr rounded-br px-2 py-1 outline-none text-right input-no-spinner`}
																	value={asset.unitPrice ?? 0}
																	min={0}
																	onInput={(e: any) => {
																		const newVal = parseFloat(e.target.value) || 0;
																		const updatedItems = [...lineItems];
																		updatedItems[index].unitPrice = newVal;
																		updatedItems[index].totalAmount = newVal * (updatedItems[index].requiredQty || 0);
																		setLineItems(updatedItems);
																	}}
																	onBlur={(e: any) => {
																		const newVal = parseFloat(e.target.value) || 0;
																		const updatedItems = [...lineItems];
																		updatedItems[index].unitPrice = newVal > 0 ? newVal : 0;
																		updatedItems[index].totalAmount = updatedItems[index].unitPrice * (updatedItems[index].requiredQty || 0);
																		setLineItems(updatedItems);
																	}}
																/>
															</div>
														</div>
													</div>
												) : (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
														${asset.unitPrice?.toFixed(2) || '0.00'}
													</div>
												)}

												{/* Quantity - Editable only in convert-po mode */}
												{mode === 'convert-po' ? (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`asset-qty-${index}`} onClick={(e: any) => {
														handleOnClickCellEdit(`asset-qty-${index}`, e);
														e.stopPropagation();
														e.preventDefault();
													}}>
														<div className={`flex items-center gap-1 flex-nowrap justify-end`}>
															<div className={`text-right`}>
																<div className={`preview-value`} title={`Click here to edit quantity`}>{asset.requiredQty || 0}</div>
																<div className={`edit-value hidden`}>
																	<input
																		type="number"
																		name={`assetrequiredqty${index}`}
																		className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner`}
																		value={asset.requiredQty ?? 0}
																		min={0}
																		onInput={(e: any) => {
																			const newQty = parseFloat(e.target.value) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].requiredQty = newQty;
																			updatedItems[index].totalAmount = (updatedItems[index].unitPrice || 0) * newQty;
																			setLineItems(updatedItems);
																		}}
																		onBlur={(e: any) => {
																			const newQty = parseFloat(e.target.value) || 0;
																			const updatedItems = [...lineItems];
																			updatedItems[index].requiredQty = newQty > 0 ? newQty : 0;
																			updatedItems[index].totalAmount = (updatedItems[index].unitPrice || 0) * updatedItems[index].requiredQty;
																			setLineItems(updatedItems);
																		}}
																	/>
																</div>
															</div>
															<div>{asset.unitCode || '--'}</div>
														</div>
													</div>
												) : (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
														{asset.requiredQty || 0} {asset.unitCode || '--'}
													</div>
												)}

												{/* Total - Editable only in convert-po mode (back-calculates unit price) */}
												{mode === 'convert-po' ? (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable" id={`asset-total-${index}`} onClick={(e: any) => {
														handleOnClickCellEdit(`asset-total-${index}`, e);
														e.stopPropagation();
														e.preventDefault();
													}}>
														<div className={`preview-value line-clamp-1 text-right`} title={`Click here to edit total`}>
															${asset.totalAmount?.toFixed(2) || '0.00'}
														</div>
														<div className={`edit-value hidden`}>
															<div className={`flex`}>
																<span className={`border border-gray-300 bg-gray-50 rounded-tl rounded-bl flex items-center justify-center px-2 py-1 border-r-0`}>$</span>
																<input
																	type="number"
																	name={`assettotal${index}`}
																	className={`w-full border border-gray-300 rounded-tr rounded-br px-2 py-1 outline-none text-right input-no-spinner`}
																	value={asset.totalAmount ?? 0}
																	min={0}
																	onInput={(e: any) => {
																		const newTotal = parseFloat(e.target.value) || 0;
																		const qty = Number(asset?.requiredQty) || 0;
																		const updatedItems = [...lineItems];
																		updatedItems[index].totalAmount = newTotal;
																		if (qty > 0) {
																			updatedItems[index].unitPrice = Number((newTotal / qty).toFixed(2));
																		}
																		setLineItems(updatedItems);
																	}}
																	onBlur={(e: any) => {
																		const newTotal = parseFloat(e.target.value) || 0;
																		const qty = Number(asset?.requiredQty) || 0;
																		const updatedItems = [...lineItems];
																		updatedItems[index].totalAmount = newTotal > 0 ? newTotal : 0;
																		if (qty > 0) {
																			updatedItems[index].unitPrice = Number((updatedItems[index].totalAmount / qty).toFixed(2));
																		}
																		setLineItems(updatedItems);
																	}}
																/>
															</div>
														</div>
													</div>
												) : (
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
														${asset.totalAmount?.toFixed(2) || '0.00'}
													</div>
												)}
											</div>
										)
									})}
								</div>
							</div>
						)}

						<div className="grid grid-cols-2 gap-x-8">
							<div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
								<div className='w-[12.5rem] text-[#767676] mr-2'>Name of Requester</div>
								<div className='text-[#323233]'>{formData.requesterName || '--'}</div>
							</div>
							<div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
								<div className='w-[12.5rem] text-[rgb(118,118,118)] mr-2'>Approved by</div>
								<div className='text-[#323233]'>{formData?.approverName || '--'}</div>
							</div>
							<div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
								<div className='w-[12.5rem] text-[#767676] mr-2'>Required By</div>
								<div className='text-[#323233]'>{showLocalDate(formData.requiredByDate) || '--'}</div>
							</div>
							<div className='flex py-6 items-center text-[0.938rem]'>
								<div className='w-[12.5rem] text-[#767676] mr-2'>Approval Date</div>
								<div className='text-[#323233]'>{formData.approvedDate ? moment.utc(formData?.approvedDate).local().format(`MM/DD/YYYY`) : `--`}</div>
							</div>
						</div>
						<div className='py-6 border-b border-gray-200 text-[0.938rem]'>
							<div className='w-[12.5rem] text-[#767676] mr-2 py-4 pt-1'>Notes to Approver</div>
							<div className='text-[#323233]'>{formData.notes || '--'}</div>
						</div>

						<div className='py-6 text-[0.938rem]'>
							<div className='w-[14rem] text-[#767676] mr-2 py-4 pt-1'>Describe Reason for Re-order</div>
							<div className='text-[#323233]'>{formData.reason || '--'}</div>
						</div>


						{pr?.purchaseRequestStatusID == 7 && (
							<>
								{POLIST.length > 0 && (
									<>
										<h4 className="font-semibold text-[0.938rem] py-4 uppercase">Purchase Orders Created</h4>
										<div className="border border-[#043E6133] rounded-[5px] parts-table mb-8">
											<div className="flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]">
												<div className="w-[30%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">PO Number</div>
												<div className="w-[20%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">PO Date</div>
												<div className="w-[25%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Vendor</div>
												<div className="w-[25%] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">Total Amount</div>
											</div>

											{POLIST.length === 0 && (
												<div className="flex items-center justify-center h-24 text-gray-500">
													No Purchase Orders found.
												</div>
											)}

											{POLIST.map((po, index) => (
												<div key={index} className={`flex items-center flex-nowrap ${index < POLIST.length - 1 ? "border-b border-[#043E6133]" : ""}`}>
													<div className="w-[30%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
														<Link to={URLS.PURCHASING.ORDER + '?open=' + po.purchaseOrderID} target='_blank' className={`line-clamp-1 text-ellipsis`}>{po.purchaseOrderCode || '--'}</Link>
													</div>
													<div className="w-[20%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">{po.addedDate ? moment.utc(po.addedDate).local().format(`MM/DD/YYYY`) : `--`}</div>
													<div className="w-[25%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">{po.vendorName || '--'}</div>
													<div className="w-[25%] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">${(po.assetTotalAmount || po.partsTotalAmount)?.toFixed(2) || '0.00'}</div>
												</div>
											))}
										</div>
									</>
								)}
							</>
						)}
					</div>

					{/* Footer */}
					<div className="bg-white px-4 py-3 border-t border-gray-300 z-10 flex justify-end mt-auto sticky bottom-0">
						<div className="flex justify-end items-center gap-1">
							{(() => {
								if (mode === `approve`) {
									return (
										<>
											<Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(3)}>Approve</Button>
											<Button theme="danger" type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(4)}>Reject</Button>
											<Button theme="secondary" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Cancel</Button>
										</>
									)
								}
								if (mode === 'convert-po') {
									return (
										<>
											<Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onConverPR_PO()}>Submit</Button>
											<Button theme="secondary" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Cancel</Button>
										</>
									)
								}
								return (
									<>
										{pr?.purchaseRequestStatusID == 1 && (
											<Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(2)}>Send for Approval</Button>
										)}
										{pr?.purchaseRequestStatusID == 2 && (
											<Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(3)}>Approve</Button>
										)}
										{pr?.purchaseRequestStatusID == 3 && (
											<Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel('convert-po')}>Convert To PO</Button>
										)}
										<Button theme="secondary" childstyle={{ padding: '4px 12px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Close</Button>
									</>
								)
							})()}
						</div>
					</div>
				</>
			)
			}
		</div >
	);

};

export default ViewPurchaseRequest;